<p-fieldset legend="Add Lessons">
    <p-message severity="info" class="my-2">
        <i class="pi pi-info-circle" style="font-size: 1rem"></i>&nbsp;&nbsp;Course code format depends on selected Shell course/s.
    </p-message>
  <form [formGroup]="addLessonsFormGroup" (ngSubmit)="onSubmit()">
    <div class="flex flex-column gap-1 my-1">
        <p-multiselect [options]="shellCourses" formControlName="selectedShellCourses" optionLabel="code" placeholder="Select Shell Course/s" [maxSelectedLabels]="5" class="w-full" display="chip" required [selectionLimit]="100"/>
      <div formArrayName="lessons" class="my-1">
        <p-button [outlined]="true" type="button" severity="primary" (click)="addLesson()" size="small" icon="pi pi-plus" label="Add a lesson"/>
          @for (lesson of lessons.controls; track $index; let i = $index) {
            <div class="flex gap-2 my-2" [formGroupName]="i">
              <p-button type="button" severity="danger" icon="pi pi-times" (click)="removeLesson(i)" [outlined]="true" size="small"/>
              <p-iftalabel class="flex-1">
                  <input id="lesson-{{ i }}" pInputText  formControlName="lesson" autocomplete="off" fluid/>
                  <label for="lesson-{{ i }}">Lesson</label>
              </p-iftalabel>
              <p-iftalabel class="flex-1">
                  <input id="passingMarks-{{ i }}" pInputText  formControlName="passingMarks" autocomplete="off" fluid/>
                  <label for="passingMarks-{{ i }}">Passing Marks</label>
              </p-iftalabel>
              <p-iftalabel class="flex-1">
                  <p-select [options]="canPostGradeToRLMSValues" formControlName="canPostGradeToRLMS" optionLabel="label" optionValue="value" placeholder="Can post grades to RLMS?" class="w-full"/>
                  <label>Can post grades to RLMS?</label>
              </p-iftalabel>
            </div>
          }
      </div>

      <div class="flex flex-row gap-1">
         <p-floatlabel variant="on" class="flex-1">
          <textarea pTextarea readonly rows="10" class="w-full font-monospace" style="resize: none;" [value]="lessonsPreview()"></textarea>
          <label>Lessons Preview</label>
        </p-floatlabel>
      </div>
      
      <p-message severity="error" class="my-2" [class.hidden]="presentCourseCodes().length === 0">
        These course code/s already exist. 🤨
            @for (code of presentCourseCodes(); track code) {
              <div>{{ code }}</div>
            }
      </p-message>
      <p-message severity="success" class="my-2" [class.hidden]="absentCourseCodes().length === 0">
        These are available and can be created. 😎
        @for (code of absentCourseCodes(); track code) {
            <div>{{ code }}</div>
        }
      </p-message>

      @if (lessons.errors?.['postGradeCount']) {
        <p-message severity="error">Only one lesson must/can post grades to RLMS.</p-message>
      }

      <p-message severity="secondary"> 
        <div class="flex gap-2 justify-content-start">
            <p-button type="button"  severity="info" label="Check Availability" 
            (onClick)="checkAvailability()"
            [disabled]="addLessonsFormGroup.invalid" 
              />
           <p-button  type="submit" label="Save" 
           [disabled]="!wasCheckAvailabilityButtonClicked() || 
           absentCourseCodes().length === 0" />
           <p-button  type="button" label="Cancel" severity="secondary" 
           (onClick)="router.navigate(['/view-lessons'])" />
        </div>
      </p-message>
    </div>
  </form>
</p-fieldset>
